// redirect from /#signup to /signup
$('document').ready(function(){
	$("[href='#signup']").click(function(){
		$("[href='#signup']").removeAttr("href");
		window.location.href = "/signup";
	});
});
